import { useMutation, useQueryClient } from "react-query";

import { zodParseWithLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import {
    getUserOrganizationRolesQueryKey,
    UserOrganizationRolesPayload,
    UserOrganizationRolesSchema,
} from "src/api/client-api/userOrganizationRoles/types";

type UpdateUserOrganizationRoles = {
    userId: number;
    organizationId: number;
    payload: UserOrganizationRolesPayload;
};

export const useUpdateUserOrganizationRoles = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ userId, organizationId, payload }: UpdateUserOrganizationRoles) => {
            const response = await loggedInApiCall.put(
                `/api/users/${userId}/organizations/${organizationId}/roles`,
                payload,
            );

            return zodParseWithLog(response.data, UserOrganizationRolesSchema, "updateUserOrganizationRoles");
        },
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries(getUserOrganizationRolesQueryKey(variables.userId, variables.organizationId));
            queryClient.invalidateQueries("allUsers");
        },
    });
};
